import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './FlexboxContainer.module.scss.js';

var _excluded = ["alignItems", "children", "className", "flexDirection", "flexWrap", "inline", "justifyContent"];
var FlexboxContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var alignItems = _ref.alignItems,
    children = _ref.children,
    className = _ref.className,
    flexDirection = _ref.flexDirection,
    flexWrap = _ref.flexWrap,
    inline = _ref.inline,
    justifyContent = _ref.justifyContent,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(inline ? style.displayInlineFlex : style.displayFlex, alignItems && "align-items-" + alignItems, flexDirection && "flex-" + flexDirection, flexWrap && "flex-" + flexWrap, justifyContent && "justify-content-" + justifyContent, className),
    ref: ref
  }, props), children);
});
FlexboxContainer.propTypes = {
  /** This defines the alignment along the cross axis. */
  alignItems: PropTypes.oneOf(['stretch', 'center', 'start', 'end', 'baseline', 'initial']),
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Whether the container is display inline-flex (true) or just flex (false) */
  inline: PropTypes.bool,
  /** Defines direction flex items are placed in the flex container */
  flexDirection: PropTypes.oneOf(['row', 'column', 'row-reverse', 'column-reverse']),
  /** Whether to wrap to the next line */
  flexWrap: PropTypes.oneOf(['wrap', 'nowrap', 'wrap-reverse']),
  /** This defines the alignment along the main axis. */
  justifyContent: PropTypes.oneOf(['start', 'end', 'center', 'between', 'around', 'initial'])
};
FlexboxContainer.defaultProps = {
  inline: false,
  flexDirection: 'row',
  flexWrap: 'nowrap'
};

export { FlexboxContainer as default };
//# sourceMappingURL=FlexboxContainer.js.map
